import React, { useEffect, useState, lazy, Suspense } from "react";
import "./App.css";
import Loader from "./components/PostEvent/Loader";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Combined from "./components/PostEvent/CombinedCarousel/Combined";
import axios from "axios";
import jsonData from "./components/PostEvent/ai-branding.json"; // Import the JSON file


const Body = lazy(() => import("./components/PostEvent/Body/Body"));
const BodyMobile = lazy(() => import("./components/PostEvent/Body/Bodymobile"));
const LogoMobile = lazy(() =>
  import("./components/PostEvent/Logo Section/Logomobile.js")
);
const Logo = lazy(() => import("./components/PostEvent/Logo Section/Logo.js"));
const Footer = lazy(() => import("./components/PostEvent/Footer/Footer"));
const SignUpForm = lazy(() =>
  import("./components/PostEvent/ContactUS/SignUpForm.js")
);
const Video = lazy(() => import("./components/PostEvent/video.js"));
const PostEventMemories = lazy(() =>
  import("./components/PostEvent/PostEventMemories/PostEventMemories.js")
);


const Thankyou = lazy(() =>
  import("./components/PostEvent/ThankYou/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import(
    "./components/PostEvent/SubscribeNotification/SubscribeForEventNotifications.js"
  )
);
const VideoHighlights = lazy(() =>
  import("./components/PostEvent/VideoHighlights/videoHighlights.js")
);
const MemoriesHighlights = lazy(() =>
  import("./components/PostEvent/MemoryHighlight/MemoriesHighlight.js")
);
const PostSocial = lazy(() =>
  import("./components/PostEvent/PostSocial/PostSocial.js")
);
const PostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/PostEventVideos.js")
);
const MobilePostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/MobilePostEventVideo.js")
);


function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const [links, setLinks] = useState(null); // Set initial state as null
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const appVersion = appversion.version;


  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
      >
<CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />

      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <Body handleVideo={handleVideo} videoToggle={videoToggle} links={links} />
        </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <BodyMobile handleVideo={handleVideo} videoToggle={videoToggle} links={links}/>
        </Suspense>
      </MediaQuery>


      <Suspense fallback={<div />}>
        <Logo />
      </Suspense>


      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <SignUpForm />
        </Suspense>
      </MediaQuery>


      {/* <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <MobilePostEventVideo
            handleVideo={handleVideo}
            videoToggle={videoToggle}
          />
        </Suspense>
      </MediaQuery> */}


      <Suspense fallback={<div />}>
        <PostEventMemories />
      </Suspense>


      <Suspense fallback={<div />}>
        <Thankyou />
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>


      <Combined />


      <Suspense fallback={<div />}>
        <Footer links={links} />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && (
          <Video handleVideo={handleVideo} videoToggle={videoToggle} />
        )}
      </Suspense>
      </CacheBuster>
    </div>
    
  );
}


export default App;


